import { render, staticRenderFns } from "./EditLimitDialog.vue?vue&type=template&id=c4d25200&scoped=true"
import script from "./EditLimitDialog.vue?vue&type=script&lang=js"
export * from "./EditLimitDialog.vue?vue&type=script&lang=js"
import style0 from "./EditLimitDialog.vue?vue&type=style&index=0&id=c4d25200&prod&lang=scss"
import style1 from "./EditLimitDialog.vue?vue&type=style&index=1&id=c4d25200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d25200",
  null
  
)

export default component.exports